<div class="cpcontent">
    <button (click)="initMap()">Init Map</button>
    <div id="pagemap" #pagemap style="width:100%;height:400px"></div>
</div>